// Alt innhold som er spesielt for denne boka. Resten av koden er lik i begge
// fargeleggingsbøkene.

export const book = {
  id: '1800',
  title: 'Litteraturen på 1800-tallet',
  pdfFileName: 'Litteraturen på 1800-tallet.pdf',
  cover: {
    imageUrl: './unnamed.png',
    intro: 'En repetisjon av romantikken, realismen, naturalismen og nyromantikken – side for side.',
    steps: [
      'Les teksten på hver side.',
      'Svar på spørsmålene og fargelegg bildet.',
      'Lag en PDF når du er ferdig, og lever den.',
    ],
  },
  // mode 'questions': teksten vises, eleven svarer på spørsmålene.
  pages: [
    {
      mode: 'questions', imageUrl: './unnamed(1).png', label: 'ROMANTIKKEN', title: 'Følelser og fantasi',
      text: 'På starten av 1800-tallet kom en reaksjon på fornuften. Nå skulle følelsene, fantasien og naturen hylles! Forfatterne og kunstnerne var opptatt av det storslåtte, det mystiske og det geniale i mennesket. Naturen var ikke bare vakker, den var et speil for sjelens innerste liv.',
      questions: ['Hvorfor tror du folk ble så opptatt av følelser og natur etter en tid preget av fornuft?'],
    },
    {
      mode: 'questions', imageUrl: './unnamed(2).png', label: 'NASJONALROMANTIKKEN', title: 'Jakten på det norske',
      text: 'I Norge brukte vi romantikken til å bygge en nasjon. Etter århundrer under Danmark skulle vi finne «den norske folkesjelen». Kunstnere malte storslått natur og bønder i bunad, og forfattere som Asbjørnsen og Moe reiste rundt og samlet inn folkeeventyr.',
      questions: [
        'Hvilke eventyr, sanger eller malerier kjenner du til fra nasjonalromantikken?',
        'Hva forteller de om Norge?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(3).png', label: 'DET MODERNE GJENNOMBRUDDET', title: 'Problemer under debatt',
      text: 'Georg Brandes krevde at litteraturen skulle «sette problemer under debatt». Romantikkens drømmerier var forbi. Nå skulle litteraturen handle om det virkelige livet.',
      questions: [
        'Hva tror du han mente med det?',
        'Hvilke problemer var viktige å diskutere på slutten av 1800-tallet?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(4).png', label: 'REALISMEN', title: 'Et speilbilde av virkeligheten',
      text: 'Realismen skulle vise virkeligheten – uten filter. Forfatterne var som fotografer som tok bilder av samfunnet og menneskene i det, spesielt borgerskapet.',
      questions: ['Hvilke «problemer» fra samfunnet rundt deg ville du skrevet om i en realistisk tekst?'],
    },
    {
      mode: 'questions', imageUrl: './unnamed(5).png', label: 'REALISMEN', title: 'Et dukkehjem',
      text: 'I starten er Nora ektemannens «lerkefugl». Hun lever i et vakkert hjem, men bærer på en stor hemmelighet.',
      questions: [
        'Hva forteller kallenavnet «lerkefugl» om ekteskapet?',
        'Hvorfor må hun skjule hemmeligheten sin?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(6).png', label: 'REALISMEN', title: 'Oppgjøret',
      text: 'Fasaden sprekker. Nora innser at hun har vært en dukke, og at hun må forlate alt for å finne seg selv.',
      questions: [
        'Hva er «det vidunderligste» Nora håper på?',
        'Hvorfor blir hun skuffet, og hva betyr det å «finne seg selv»?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(7).png', label: 'REALISMEN', title: 'Karen – et offer for en løgn',
      text: 'Alexander Kielland var en av realismens store forfattere. I novellen «Karen» arbeider en stille, ung pike på Krarup Kro. Hun forelsker seg i den kjekke postføreren i den røde kappen. Samme kveld hører hun at han er gift og har to barn. Karen løper ut i heden og kommer aldri tilbake.',
      questions: [
        'Hvordan bruker Kielland vinden, reven og haren i fortellingen?',
        'Hvem har egentlig skylden for det som skjer med Karen?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(8).png', label: 'NATURALISMEN', title: 'Arv og miljø',
      text: 'Naturalismen tar realismen et skritt videre. Her er alt mørkere, og skjebnen virker forutbestemt. Forfatterne mente mennesket var et produkt av arv og miljø. De skrev om de fattigste og mest utsatte i samfunnet.',
      questions: [
        'Hva betyr arv og miljø for hvem du er?',
        'Tror du vi har fri vilje?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(9).png', label: 'NATURALISMEN', title: 'Uten håp',
      text: 'I Amalie Skrams «Karens jul» møter vi en fattig kvinne som fryser i hjel med barnet sitt i et skur på havna. Ingen griper inn for å hjelpe.',
      questions: ['Hvorfor er dette en typisk naturalistisk fortelling?'],
    },
    {
      mode: 'questions', imageUrl: './unnamed(10).png', label: 'NATURALISMEN', title: 'En uunngåelig skjebne?',
      text: 'Begge «Karen»-historiene ender tragisk. De er ofre for et samfunn og for omstendigheter de ikke kan endre.',
      questions: [
        'Er skjebnen deres uunngåelig?',
        'Hva sier disse historiene om samfunnet den gang?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(11).png', label: 'NYROMANTIKKEN', title: 'Sjelen vender tilbake',
      text: 'Mot slutten av århundret kom en reaksjon på naturalismens mørke. Forfatterne vendte blikket innover igjen, mot sjelens mysterier, drømmer og angst. Nyromantikken brukte stemninger og symboler for å utforske det indre landskapet.',
      questions: [
        'Hva skiller nyromantikken fra naturalismen?',
        'Hvorfor tror du forfatterne ble opptatt av drømmer og angst mot slutten av 1800-tallet?',
      ],
    },
    {
      mode: 'questions', imageUrl: './unnamed(12).png', label: 'NYROMANTIKKEN', title: 'Jeg ser',
      text: 'Sigbjørn Obstfelder er den fremste nyromantiske dikteren i Norge. Hans dikt «Jeg ser» fanger følelsen av fremmedgjøring i den moderne byen. «Jeg ser paa den hvide himmel, / jeg ser paa de graablaa skyer, / jeg ser paa den blodige sol.» Diktet beskriver en person som ser verden som om det er for første gang, og føler seg helt utenfor.',
      questions: [
        'Hvordan bruker Obstfelder enkle ord for å skape en følelse av fremmedgjøring?',
        'Har du noen gang følt deg slik?',
      ],
    },
  ],
};
